import { z } from 'zod/v4-mini';

import { FileToUpload } from '@/models/FileModel';
import { Schema, cz } from '@/utils/zodUtils.ts';

export type ChatVisibilityType = 'all' | 'practitioners';

export type Sender = {
  userType: 'practitioner' | 'patient';
  id: string;
  familyName: string;
  givenName: string;
};

export type Message = {
  id: string;
  visibility: ChatVisibilityType;
  contentText?: string;
  subject: string;
  createdAt: string;
  sender: Sender;
  attachment: { url: string; name: string }[];
};

export const messageSchema: Schema<Message> = z.object({
  id: z.string(),
  visibility: z.literal(['all', 'practitioners']),
  contentText: cz.optional(z.string()),
  subject: z.string(),
  createdAt: z.string(),
  sender: z.object({
    userType: z.literal(['practitioner', 'patient']),
    id: z.string(),
    givenName: z.string(),
    familyName: z.string(),
  }),
  attachment: cz.forcedArray(
    z.object({
      url: z.string(),
      name: z.string(),
    }),
  ),
});

export type CreateMessage = {
  visibility: ChatVisibilityType;
  contentText?: string;
  contentAttachment?: FileToUpload[];
};
